import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './MainCatalogSelect.html?raw';
import on from 'dojo/on';
import { MainCatalogTypes, MainCatalogs_Classes } from "../_loadingHelpers/MainCatalogTypes";
import SearchSelect from '../../moreCore/UI/SearchSelect/SearchSelect';
import {                                
    ActivityStatusEditor,               // *************************************************************
    BookingStatusEditor,                // !! WICHTIG !!
    DutyTypeEditor,                     // Verwenden Sie MainCatalogEditorTools für alle Editor Importe, 
    FunctionalGroupEditor,              // um Probleme mit zirkulärer Abhängigkeit zu vermeiden
    FunctionalMainGroupEditor,          // *************************************************************
    VenueEditor,
    RoomEditor,
    ServiceCategoriesEditor,
    ServicePackagesEditor,
    EvCategories_1_Editor,
    EvCategories_2_Editor,
    AddressCategoriesEditor,
    AddressMainCategoriesEditor,
    FileCategoryEditor,
    EvTaskDescriptEditor,
    EvTaskDescriptGroupEditor,
    EvServiceEditor,
    ProfessionsEditor,
} from './MainCatalogEditorTools';
import MainCatalogsEditorBase from '../MainCatalogsEditor/MainCatalogsEditorBase';

class MainCatalogSelect extends compose(_WidgetBaseSP) {
    templateString: any = template;

    value: string = null;
    label: string = "";

    showEditForm: boolean = false;
    isFormOpened: boolean = false;
    private useEditButton: boolean = false;

    catalogClass: MainCatalogs_Classes;
    editForm: MdsLax<InstanceType<typeof MainCatalogsEditorBase>>;

    editFormMainHeader: HTMLElement;

    catalogLabelContainer: HTMLElement;
    catalogEditContainer: HTMLElement;
    editFrame: HTMLElement;
    catalogActionContainer: HTMLElement;

    catalogButtonShowEdit: HTMLButtonElement;
    catalogButtonAddNew: HTMLButtonElement;

    catalogEditErrorContainer: HTMLElement;
    catalogEditErrorMessage: HTMLElement;

    catalogSearchSelect: MdsLax<InstanceType<typeof SearchSelect>>;

    loadListInfo(id?: string): void {

        if (!id) this.catalogSearchSelect.loadListValues();
        else this.catalogSearchSelect.loadListValues(id, true);

        //this.UiModder.domClass.add(this.catalogSearchSelect.scrollContainer, "w3-2018-coconut-milk");
    }

    setLabel(label: string): void {

        this.label = label;
        this.catalogLabelContainer.innerHTML = this.label;

        label ? this.UiModder.domClass.remove(this.catalogLabelContainer, "w3-hide") : this.UiModder.domClass.add(this.catalogLabelContainer, "w3-hide");  
    }

    setEditButtonVisibility(visible: boolean = true) {
        this.useEditButton = visible === true;

        this.UiModder.domClass.toggle(this.catalogButtonShowEdit, "w3-hide", this.useEditButton != true);
    }

    setCatalog(catalogClass: MainCatalogs_Classes, label: string, showEditForm: boolean, presetValue?: string): void {

        if (this.editForm) this.editForm.destroy();

        this.catalogClass = catalogClass;

        this.showEditForm = showEditForm;

        this.setLabel(label);

        if (this.showEditForm) {

            switch (catalogClass) {
                case MainCatalogs_Classes.EvActivityStatus:

                    this.editForm = new ActivityStatusEditor();
                    this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_ActivityStatus");
                    this.catalogSearchSelect.labelAttribute = "gDisp_1";
                    break;

                case MainCatalogs_Classes.EvBookingStatus:

                    this.editForm = new BookingStatusEditor();
                    this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_BookingStatus");
                    this.catalogSearchSelect.labelAttribute = "gDisp_1";
                    break;

                case MainCatalogs_Classes.OMDutyType:

                    this.editForm = new DutyTypeEditor();
                    this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_DutyType");
                    this.catalogSearchSelect.labelAttribute = "$Displayname";
                    break;

                case MainCatalogs_Classes.FunctionalGroup:

                    this.editForm = new FunctionalGroupEditor();
                    this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_FunctionalGroup");
                    this.catalogSearchSelect.labelAttribute = "$Displayname";
                    break;

                case MainCatalogs_Classes.FunctionalMainGroup:

                    this.editForm = new FunctionalMainGroupEditor();
                    this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_FunctionalMainGroup");
                    this.catalogSearchSelect.labelAttribute = "$Displayname";
                    break;

                case MainCatalogs_Classes.Venues:

                    this.editForm = new VenueEditor();
                    this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_Venue");
                    this.catalogSearchSelect.labelAttribute = "gDisp_1";
                    break;

                case MainCatalogs_Classes.EvRoom:

                    this.editForm = new RoomEditor();
                    this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_Room");
                    this.catalogSearchSelect.labelAttribute = "gDisp_1";
                    break;

                case MainCatalogs_Classes.EvServices:

                    this.editForm = new EvServiceEditor();
                    this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_EvService");
                    this.catalogSearchSelect.labelAttribute = "description";
                    break;

                case MainCatalogs_Classes.ServiceCategory:

                    this.editForm = new ServiceCategoriesEditor();
                    this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_ServiceCategory");
                    this.catalogSearchSelect.labelAttribute = "description";
                    break;

                case MainCatalogs_Classes.ServicePackage:

                    this.editForm = new ServicePackagesEditor();
                    this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_ServicePackages");
                    this.catalogSearchSelect.labelAttribute = "description";
                    break;

                case MainCatalogs_Classes.EvCategory_1:

                    this.editForm = new EvCategories_1_Editor();
                    this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_EvCategories");
                    this.catalogSearchSelect.labelAttribute = "description";
                    break;

                case MainCatalogs_Classes.EvCategory_2:

                    this.editForm = new EvCategories_2_Editor();
                    this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_EvCategories");
                    this.catalogSearchSelect.labelAttribute = "description";
                    break;

                case MainCatalogs_Classes.AddressMainCategory:

                    this.editForm = new AddressMainCategoriesEditor();
                    this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_AddressMainCategories");
                    this.catalogSearchSelect.labelAttribute = "description";
                    break;

                case MainCatalogs_Classes.AddressCategory:

                    this.editForm = new AddressCategoriesEditor();
                    this.catalogSearchSelect.setPlaceholder("MainCatalogsEditor_Placeholder_AddressCategories");
                    this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_AddressCategories");
                    this.catalogSearchSelect.labelAttribute = "description";
                    break;

                case MainCatalogs_Classes.EvTaskDescript:

                    this.editForm = new EvTaskDescriptEditor();
                    this.catalogSearchSelect.setPlaceholder("MainCatalogsEditor_Placeholder_EvTaskDescript");
                    this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_EvTaskDescript");
                    this.catalogSearchSelect.labelAttribute = "description";
                    break;

                case MainCatalogs_Classes.EvTaskDescriptGroup:

                    this.editForm = new EvTaskDescriptGroupEditor();
                    this.catalogSearchSelect.setPlaceholder("MainCatalogsEditor_Placeholder_EvTaskDescriptGroup");
                    this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_EvTaskDescriptGroup");
                    this.catalogSearchSelect.labelAttribute = "description";
                    break;

                case MainCatalogs_Classes.FileCategory:

                    this.editForm = new FileCategoryEditor();
                    this.catalogSearchSelect.setPlaceholder("MainCatalogsEditor_Placeholder_FileCategory");
                    this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_FileCategory");
                    this.catalogSearchSelect.labelAttribute = "$Displayname";
                    break;
                case MainCatalogs_Classes.Professions:
                    this.editForm = new ProfessionsEditor();
                    this.catalogSearchSelect.setPlaceholder("MainCatalogsEditor_Placeholder_Professions");
                    this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_FileCategory");
                    this.catalogSearchSelect.labelAttribute = "$Displayname";
                    break;
                default:
                    console.warn("Main catalogs: unknown catalog class " + catalogClass);
                    return;
                    break;
                    
            }
            this.editForm.setCloseButton(true);
            this.catalogSearchSelect.setRequestParameter("entityClass", this.catalogClass);
            this.catalogSearchSelect.setUrl("MainCatalogsEditor/LoadMainCatalogSelect");
            //this.editForm.placeAt(this.catalogEditContainer);
            //this.UiModder.domConstruct.place(this.editForm.domNode, this.catalogEditContainer);
            this.UiModder.domConstruct.place(this.editForm.domNode, this.editFrame);
            
            this.setUpEventListeners();
        } else {
            this.hideNode(this.catalogEditContainer);
            this.UiModder.domConstruct.empty(this.editFrame);
        }

        if (presetValue) this.value = presetValue;
        this.loadListInfo(presetValue);
    }

    setUpEventListeners(): void {

        on(this.editForm, "CatalogEntityData_Response", lang.hitch(this, this._onEvent_Response));
        on(this.editForm, "CatalogEntityData_Close", lang.hitch(this, this._onEvent_Close));
        on(this.editForm, "CatalogEntityData_Save", lang.hitch(this, this._onEvent_Save));
        on(this.editForm, "CatalogEntityData_Error", lang.hitch(this, this._onEvent_Error));
        on(this.editForm, "CatalogEntityData_NoId", lang.hitch(this, this._onEvent_NoId));
    }

    _onEvent_NoId(): void {

        this.StandbyStop();
        this.UiModder.domClass.add(this.catalogEditContainer, "w3-hide");
    }

    _onEvent_Save(id: string) {

        this.loadListInfo(id);
        this.value = id;
        this.emitChangeEvent();
        this.UiModder.domClass.remove(this.catalogButtonAddNew, "w3-disabled");
    }

    _onEvent_Response(): void {
        this.UiModder.domClass.remove(this.catalogEditContainer, "w3-hide");
        this.UiModder.domClass.remove(this.catalogSearchSelect.domNode, "ego_animated_progressBar");
        this.isFormOpened = true;
        this.StandbyStop();
    }

    _onEvent_Close(): void {

        this._showErrorMessage(false);

        this.UiModder.domClass.add(this.catalogEditContainer, "w3-hide");
        this.UiModder.domClass.remove(this.catalogButtonAddNew, "w3-disabled");
        this.isFormOpened = false;

        // Select ausleeren
        this.catalogSearchSelect.setValue(null);
    }

    _onEvent_Error(msg: string) {

        this.StandbyStop();
        this.loadListInfo();
        this._showErrorMessage(true, msg);
    }

    _onClickButtonShowEdit(): void {

        this._showErrorMessage(false);

        this.StandbyStart();
        this._changeEditorMainHeader("edit");

        this.editForm.getEditFormInfo(this.catalogSearchSelect.getValue());
        this.UiModder.domClass.remove(this.catalogButtonAddNew, "w3-disabled");

        this.editForm.emit("MainCatalogSelect_ShowHideAddChange");
    }

    _onClickButtonAddNew(): void {

        this._showErrorMessage(false);

        this._changeEditorMainHeader("new");

        this.editForm.prepareFormData();
        this.UiModder.domClass.remove(this.catalogEditContainer, "w3-hide");
        this.UiModder.domClass.add(this.catalogButtonAddNew, "w3-disabled");
        
        this.editForm.emit("MainCatalogSelect_ShowHideAddChange");
    }

    _changeEditorMainHeader(header: "new" | "edit"): void {

        switch (header) {
            case "new":
                this.editFormMainHeader.innerHTML = this.translations["MainCatalogsEditor_Form_MainHeader_New"];
                break;
            case "edit":
                this.editFormMainHeader.innerHTML = this.translations["MainCatalogsEditor_Form_MainHeader_Edit"];
                break;
        }
    }


    _onChangeCatalogSearchSelect(): void {

        this._showErrorMessage(false);
        this.UiModder.domClass.remove(this.catalogButtonAddNew, "w3-disabled");

        this.value = this.catalogSearchSelect.getValue();

        this.emitChangeEvent();


        if (this.useEditButton != true || this.value === null) {
            // wenn bereits geöffnet - ungespeicherte Änderungen??
            if (this.isFormOpened) {
                // ??


                this.UiModder.domClass.remove(this.catalogEditContainer, "w3-hide");
            }

            this.editForm.getEditFormInfo(this.value);

            this._changeEditorMainHeader("edit");

            this.UiModder.domClass.toggle(this.catalogSearchSelect.domNode, "ego_animated_progressBar", this.value != null);
        }

    }

    _showErrorMessage(bool: boolean, msg?: string) {

        if (bool) {

            this.UiModder.domClass.remove(this.catalogEditErrorContainer, "w3-hide");
            msg ? this.catalogEditErrorMessage.innerHTML = msg : this.catalogEditErrorMessage.innerHTML = "...error occured";
        } else {

            this.UiModder.domClass.add(this.catalogEditErrorContainer, "w3-hide");
            this.catalogEditErrorMessage.innerHTML = "";
        }
    }

    emitChangeEvent(): void {

        this.emit("change");
    }

    setValue(value: string): void {

        this.catalogSearchSelect.setValue(value);
    }

    getValue(): string {

        return this.value;
    }

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(MainCatalogSelect.prototype, {
  catalogSearchSelect: () => (new SearchSelect()),
});
export default mdsWidget(MainCatalogSelect);